import React from 'react';
import { Banknote, RefreshCw, Calendar, AlertCircle, CheckCircle, Users, ReceiptText, Handshake } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { formatNumber, formatMontant } from './recouvrementUtils';

// En-tete calque sur MaCaisse : bandeau bleu #246990, titre + icone,
// actions a droite, puis rangee de pastilles de statut.
const RecouvrementHeader = ({
  currentUser,
  anneeCreance,
  anneeActive,
  elevesConcernes,
  resteARecouvrer,
  onRefresh,
  refreshing
}) => {
  return (
    <>
      <Card className="border-0 shadow-sm overflow-visible relative z-10">
        <CardHeader className="bg-[#246990] text-white rounded-t-lg overflow-visible">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <CardTitle className="flex items-center gap-3 text-2xl">
                <Handshake size={32} />
                Recouvrement
              </CardTitle>
              <p className="text-white text-sm mt-1 font-semibold">
                Chargé du recouvrement : {currentUser?.nom} {currentUser?.prenom}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              {anneeCreance?.nom && (
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2">
                  <Calendar size={18} className="text-white" />
                  <div>
                    <p className="text-[11px] uppercase tracking-wide text-white/70 leading-none">Année de la créance</p>
                    <p className="text-sm font-semibold text-white mt-0.5">{anneeCreance.nom}</p>
                  </div>
                </div>
              )}


            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 mt-2">
            {resteARecouvrer > 0 ? (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-orange-500/20 text-white border border-white/30">
                <AlertCircle size={14} className="mr-1" />
                {formatMontant(resteARecouvrer)} à recouvrer
              </span>
            ) : (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-green-500/20 text-white border border-white/30">
                <CheckCircle size={14} className="mr-1" />
                Aucune créance en cours
              </span>
            )}

            {elevesConcernes > 0 && (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-white/15 text-white border border-white/30">
                <Users size={14} className="mr-1" />
                {formatNumber(elevesConcernes)} élève{elevesConcernes > 1 ? 's' : ''} concerné{elevesConcernes > 1 ? 's' : ''}
              </span>
            )}

            {anneeActive?.nom && (
              <span className="inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold bg-white/15 text-white border border-white/30">
                <Calendar size={14} className="mr-1" />
                Traité depuis {anneeActive.nom}
              </span>
            )}
          </div>
        </CardHeader>
      </Card>

      {/* Note d'information -- meme traitement que MaCaisse */}
      <div className="mt-6 p-4 bg-[#f9f0ee] rounded-lg border border-[#ae7467]/20 flex items-center">
        <div className="p-2 bg-[#ae7467] rounded-full mr-4">
          <ReceiptText className="text-white" size={20} />
        </div>
        <div className="flex-1">
          <h5 className="font-medium text-[#ae7467]">information importante</h5>
          <p className="text-sm text-gray-700 leading-relaxed">
            Ce module suit les <strong>frais scolaires encore dus</strong> sur les années déjà clôturées.
            Les créances restent rattachées à <strong>l'année d'origine</strong> : un paiement encaissé aujourd'hui
            solde la dette de l'année concernée et n'est jamais comptabilisé sur l'année active.
            <br /><br />
            Le recouvrement se pilote depuis l'année active :
            <span className="font-semibold text-[#ae7467]"> une année archivée ne permet que la consultation.</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default RecouvrementHeader;
